import { Action } from 'redux';
import * as actions from './actions';
import { ErrorAction } from '../common/error-action';
import { LoadingAction } from '../common/loading-action';
import { GetCatalogQueryParams } from '@services/catalogs/types/api/get-catalog-query';
import CatalogReleaseConnection from '@common/types/catalog/catalog-release-connection';
import { CatalogReleaseSortBy } from '@common/types/catalog/catalog-release-request';

export class GetCatalog implements LoadingAction {
  readonly type = actions.GET_CATALOG;
  readonly isLoading = true;
  constructor(public params: Partial<GetCatalogQueryParams> = {}) {}
}

export class GetCatalogSuccess implements LoadingAction {
  readonly type = actions.GET_CATALOG_SUCCESS;
  readonly isLoading = false;

  constructor(
    public ownerType: 'OWNER' | 'WRITER' | 'COLLABORATOR',
    public catalog: CatalogReleaseConnection,
    public isPaginating?: boolean
  ) {}
}

export class GetCatalogError implements ErrorAction {
  readonly type = actions.GET_CATALOG_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class SortCatalog implements Action {
  readonly type = actions.SORT_CATALOG;

  constructor(public sortBy: CatalogReleaseSortBy) {}
}

export class ResetCatalogStore implements Action {
  readonly type = actions.RESET_CATALOG_STORE;
}

export class ResetArtistCatalogStore implements Action {
  readonly type = actions.RESET_ARTIST_CATALOG_STORE;
}

export class CreateCombinedCatalog implements Action {
  readonly type = actions.CREATE_COMBINED_CATALOG;
}

export type CatalogActions =
  | GetCatalog
  | GetCatalogSuccess
  | GetCatalogError
  | SortCatalog
  | ResetCatalogStore
  | ResetArtistCatalogStore
  | CreateCombinedCatalog;
